import { useContext, useMemo } from 'react';

// contexts
import { EditorContext } from '../../context/EditorContext';

import useVariantsByMessageContentIdQuery from 'hooks/variants/useVariantsByMessageContentIdQuery';

import { LabelSyncWarnings, showWarningIconInEditor } from './helper';

export const useLockFormulaWarning = () => {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const { data: alternateData } = useVariantsByMessageContentIdQuery(
        Number(formula?.id!),
    );

    const { warnings: labelWarningComponents, unreachableAlternateIds } =
        useMemo<LabelSyncWarnings>(
            () =>
                showWarningIconInEditor(
                    alternateData ?? [],
                    !!formula?.is_labeled_matching_enabled,
                ),
            [alternateData, formula],
        );

    const hasWarning = useMemo<boolean>(
        () => Object.values(labelWarningComponents).some(Boolean),
        [labelWarningComponents],
    );

    return {
        hasWarning,
        labelWarningComponents,
        unreachableAlternateIds,
    };
};
